import script from "./AbstractComp.vue?vue&type=script&setup=true&lang=js"
export * from "./AbstractComp.vue?vue&type=script&setup=true&lang=js"

import "./AbstractComp.vue?vue&type=style&index=0&id=0b108e46&lang=css"

const __exports__ = script;

export default __exports__